<template>
  <!-- 头部整体盒子 -->
  <div id="header" :class="['container-fuild', headerIsFixed]">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>xxx@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <router-link to="/">
          <img src="../assets/img/logo.png">
        </router-link>
      </div>
      <!-- 导航内容 -->

      <div class="login-hui">
        <div>
          <a href="https://pay.iceriverbj.com/admin/#/" target="_blank">登录</a>
        </div>
      </div>

      <ul class="header-nav-wrapper">
        <!-- {{ $router.path }} -->
        <!-- index==navIndex && -->
        <li v-for="(item,index) in navList" :key="index" :class="[( isActive(item.path)) ?'active':'' ]" @click="navClick(index,item.name, item.path)">
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
        <!-- <li class="active login-hui">

        </li> -->
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <router-link to="/">
          <img class="center-block" style="width: 72px; height: 32px;" src="../assets/img/logo.png" alt="logo">
        </router-link>
      </div>
      <!-- 导航栏 -->
      <div class="MenuTopBarIcon" @click="openMenu()">
        <div class="MobileMenuSwitch">
          <span :class="
              menuStatus
                ? 'MenuButtonFirstGoOpen'
                : 'MenuButtonFirstGoClose'
            "></span>
          <span :class="
              menuStatus
                ? 'MenuButtonSecondGoOpen'
                : 'MenuButtonSecondGoClose'
            "></span>
          <span :class="
              menuStatus
                ? 'MenuButtonThirdGoOpen'
                : 'MenuButtonThirdGoClose'
            "></span>
        </div>
      </div>

      <!-- <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''" @click="navClick(index,item.name, item.path)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div> -->
    </div>
    <template v-if="!$isPC">
      <div class="saide-bar-bj" v-if="menuStatus" @click="openMenu()">
        <el-aside class="saide-bar" style="width: 200px;">
          <el-scrollbar class="scrollbar-wrapper">
            <el-menu class="saide-bar-menu" active-text-color="red" :default-active="activeMenu" :unique-opened="false" :collapse-transition="false" mode="vertical" router @select="select" @open="handleOpen" :default-openeds="['/software', '/fuwuware',]">
              <sidebar-item v-for="route in navList" :key="route.name" :item="route" :base-path="route.path" />
            </el-menu>
          </el-scrollbar>
        </el-aside>
      </div>
    </template>

  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import sidebarItem from "./sidebar-item.vue";
let bodyEl = document.body
let top = 0

function stopBodyScroll (isFixed) {
  if (isFixed) {
    top = window.scrollY

    bodyEl.style.position = 'fixed'
    // bodyEl.style.top = -top + 'px'
    bodyEl.style.left = 0 + 'px'
    bodyEl.style.right = 0 + 'px'
  } else {
    bodyEl.style.position = ''
    bodyEl.style.top = ''

    window.scrollTo(0, top) // 回到原先的top
  }
}
export default {
  name: "Header",
  components: {
    sidebarItem,
  },
  data () {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/home",
          children: []
        },
        {
          name: "公司简介",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "案例展示",
          path: "/software",
          children: [
            {
              name: "会务会展",
              path: "/software/smartTown"
            },
            {
              name: "展览展示",
              path: "/software/bigData"
            }
          ]
        },
        {
          name: "产品服务",
          path: "/fuwuware",
          children: [
            {
              path: '/fuwuware/fuwu1',
              name: '冰河学术活动管理系统'
            }, {
              path: '/fuwuware/fuwu2',
              name: '现场注册签到平台'
            }, {
              path: '/fuwuware/fuwu3',
              name: '会场幻灯片传输系统'
            }, {
              path: '/fuwuware/fuwu4',
              name: '冰河直播系统'
            }, {
              path: '/fuwuware/fuwu5',
              name: '冰河征文系统'
            }, {
              path: '/fuwuware/fuwu6',
              name: '冰河线下壁报系统'
            }, {
              path: '/fuwuware/fuwu7',
              name: '企业数字营销服务'
            }
          ]
        },
        // {
        //   name: "相关服务",
        //   path: "/service",
        //   children: []
        // },
        // {
        //   name: "新闻动态",
        //   path: "/newsinformation",
        //   children: []
        // },

        // {
        //   name: "工作机会",
        //   path: "/jobchance",
        //   children: []
        // },
        // {
        //   name: "联系我们",
        //   path: "/contactus",
        //   children: []
        // }
      ]
    };
  },
  computed: {
    headerIsFixed () {
      const fuwuware = ['/fuwuware/fuwu1', '/fuwuware/fuwu2', '/fuwuware/fuwu3', '/fuwuware/fuwu4', '/fuwuware/fuwu5', '/fuwuware/fuwu6', '/fuwuware/fuwu7'].includes(this.$route.path)
      // if (this.$isPC && (this.$route.path == '/' || this.$route.path == '/home' || fuwuware)) {
      if ((this.$route.path == '/' || this.$route.path == '/home' || fuwuware)) {
        return 'headerIsFixed'
      } else {
        return 'aaa'
      }

    },
    activeMenu () {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return `${meta.activeMenu}`
        // return meta.activeMenu
      }
      return `${path}`
      return path
    },
    isActive () {
      return val => {
        const fuwuware = ['/fuwuware/fuwu1', '/fuwuware/fuwu2', '/fuwuware/fuwu3', '/fuwuware/fuwu4', '/fuwuware/fuwu5', '/fuwuware/fuwu6', '/fuwuware/fuwu7'].includes(this.$route.path)
        const software = ['/software/smartTown', '/software/bigData'].includes(this.$route.path)
        if (fuwuware && val == '/fuwuware') {
          return true
        } else if (software && val == '/software') {
          return true
        } else if ('/companyintroduction' == this.$route.path && val == '/companyintroduction') {
          return true
        } else if ('/home' == this.$route.path && val == '/') {
          return true
        } else {
          return false
        }
      }
    },
    ...mapState({
      menuStatus: state => state.layout.menuStatus,
    }),
    ...mapGetters(['isClose']),
  },
  methods: {
    ...mapActions({
      OpenMenu: 'OpenMenu',
      // isCollapse: 'isCollapse'
    }),
    handleOpen (index) {
      console.log(index);
    },

    navClick (index, name, path) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;
      // if (this.$router.path == path) return;
      // this.$router.push({ path }).catch(err => { })
    },
    menuClick () {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    openMenu () {
      this.OpenMenu(window.screen.width > 997 ? this.menuStatus : !this.menuStatus)
      stopBodyScroll(this.menuStatus)
    },
    select () {
      if (window.screen.width < 997) {
        this.OpenMenu(false)
        stopBodyScroll(false)
      }
    },
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  /* background: #f4f4f4; */
  transition: all ease 0.6s;
}
.headerIsFixed {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  /* width: 95px;
  height: 45px; */
  width: 140px;
  height: 56px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #383838;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #0072f0;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #0072f0;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #0072f0;
  text-decoration: none;
  border-bottom: 2px solid #0072f0;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  /* box-shadow: 0 0 3px 1px #ccc; */
  background: #fff;
  border-radius: 5px;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  /* border-bottom: 1px solid #ccc; */
}
.activeRouter {
  color: #0072f0 !important;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:first-child {
  border-radius: 5px 5px 0 0;
  /* border-bottom: 1px solid #ccc; */
}
#header .header-nav .header-nav-wrapper > li > dl > dt:last-child {
  border-radius: 0 0 5px 5px;
  /* border-bottom: 1px solid #ccc; */
}
#header .header-nav .header-nav-wrapper > li > dl > dt a {
  color: #383838;
  /* border-bottom: 1px solid #ccc; */
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
  color: #0072f0 !important;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #dde8f3;
}
#header .header-nav .login-hui {
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 110px;
}
#header .header-nav .login-hui > div {
  /* width: 157px;
  height: 43px; */
  padding: 6px 16px;
  background: #0072f0;
  border-radius: 16px;
  font-size: 16px;
  font-family: SourceHanSansSC;
  font-weight: 400;
  /* color: #ffffff !important; */
}
#header .header-nav .login-hui > div a {
  color: #fff !important;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
    display: flex !important;
    justify-content: space-between;
    padding: 10px;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    /* height: 80px; */
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    /* position: absolute;
    top: 10px;
    left: 10px; */
    /* right: 0;
    bottom: 0; */
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
  .el-aside {
    width: 100%;
    background-color: #f5f5f5;
    color: #333;
    text-align: center;
    line-height: 200px;
    position: absolute;
    /* z-index: 10000; */
  }
  .saide-bar-bj {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    height: 100%;
    z-index: 8000;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .saide-bar {
    height: 100%;
    color: rgb(45, 45, 45);
    text-align: center;
    line-height: 200px;
    position: relative;
    background-color: #f5f5f5;
    transition: width 0.28s;
    z-index: 9000;
  }
  .menu-empty {
    color: #b6b6b6;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    padding: 0 10px;
  }
  .scrollbar-wrapper {
    height: calc(100vh - 60px) !important;
  }
  .saide-bar-menu {
    border-right: 0 !important;
  }
  .saide-bar {
    background-color: #fff;
  }
  .quic-out {
    cursor: pointer;
    border-top: 1px solid #f5f5f5;
    bottom: 1px;
  }
  /* 展开折叠按钮 */
  .MenuTopBarIcon {
    float: left;
    display: inline-block;
    margin-top: 8px;
    cursor: pointer;
    position: relative;
    z-index: 999999;
  }

  .MobileMenuSwitch {
    box-sizing: border-box;
    width: 24px;
    height: 24px;
    margin-left: auto;
  }

  .MobileMenuSwitch span {
    display: block;
    width: 20px;
    height: 3px;
    background: #0072f0;

    margin: 0 auto 4px;
    position: relative;
    border-radius: 3px;
  }
  /*给移动端菜单按钮，第一个横杠设置动画*/
  .MenuButtonFirstGoOpen {
    animation: MenuButtonGoOpen 0.3s linear;
    animation-fill-mode: forwards;
  }
  .MenuButtonFirstGoClose {
    animation: MenuButtonGoClose 0.3s linear;
    animation-fill-mode: forwards;
  }
}
@keyframes MenuButtonGoOpen {
  0% {
    -ms-transform: rotate(-8deg); /* IE 9 */
    transform: rotate(-8deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  25% {
    -ms-transform: rotate(-16deg); /* IE 9 */
    transform: rotate(-16deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  50% {
    -ms-transform: rotate(-25deg); /* IE 9 */
    transform: rotate(-25deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  75% {
    -ms-transform: rotate(-34deg); /* IE 9 */
    transform: rotate(-34deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  100% {
    -ms-transform: rotate(-43deg); /* IE 9 */
    transform: rotate(-43deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
}
@keyframes MenuButtonGoClose {
  0% {
    -ms-transform: rotate(-43deg); /* IE 9 */
    transform: rotate(-43deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  25% {
    -ms-transform: rotate(-34deg); /* IE 9 */
    transform: rotate(-34deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  50% {
    -ms-transform: rotate(-25deg); /* IE 9 */
    transform: rotate(-25deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  75% {
    -ms-transform: rotate(-16deg); /* IE 9 */
    transform: rotate(-16deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  100% {
    -ms-transform: rotate(0deg); /* IE 9 */
    transform: rotate(0deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
}

.MenuButtonSecondGoOpen {
  opacity: 0;
}
.MenuButtonSecondGoClose {
  -webkit-animation: MenutionGoCloseSeFloor 0.5s linear;
  -o-animation: MenutionGoCloseSeFloor 0.5s linear;
  animation: MenutionGoCloseSeFloor 0.5s linear;
  animation-fill-mode: forwards;
}
@keyframes MenutionGoCloseSeFloor {
  0% {
    /*background: white;*/
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/*给移动端菜单按钮，第3个横杠设置动画*/
.MenuButtonThirdGoOpen {
  animation: MenuButtonGoOpenThFloor 0.3s linear;
  animation-fill-mode: forwards;
}
.MenuButtonThirdGoClose {
  animation: MenuButtonGoCloseThFloor 0.3s linear;
  animation-fill-mode: forwards;
}
@keyframes MenuButtonGoOpenThFloor {
  0% {
    -ms-transform: rotate(8deg); /* IE 9 */
    transform: rotate(8deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  25% {
    -ms-transform: rotate(16deg); /* IE 9 */
    transform: rotate(16deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  50% {
    -ms-transform: rotate(25deg); /* IE 9 */
    transform: rotate(25deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  75% {
    -ms-transform: rotate(34deg); /* IE 9 */
    transform: rotate(34deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  100% {
    -ms-transform: rotate(43deg); /* IE 9 */
    transform: rotate(43deg);
    -moz-transform-origin: top right;
    -webkit-transform-origin: top right;
    -o-transform-origin: top right;
  }
}
@keyframes MenuButtonGoCloseThFloor {
  0% {
    -ms-transform: rotate(43deg); /* IE 9 */
    transform: rotate(43deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  25% {
    -ms-transform: rotate(34deg); /* IE 9 */
    transform: rotate(34deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  50% {
    -ms-transform: rotate(25deg); /* IE 9 */
    transform: rotate(25deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  75% {
    -ms-transform: rotate(16deg); /* IE 9 */
    transform: rotate(16deg);
    -moz-transform-origin: 100% 100%;
    -webkit-transform-origin: 100% 100%;
    -o-transform-origin: 100% 100%;
  }
  100% {
    -ms-transform: rotate(0deg); /* IE 9 */
    transform: rotate(0deg);
    -moz-transform-origin: top right;
    -webkit-transform-origin: top right;
    -o-transform-origin: top right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue